import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Card, LoadingBlur } from '@ics-portal/guardian';
import {
    AdminMappingsIcons,
    AdminPSSProjectClassificationTemplatesIcons,
    AdminRequirementsIcons,
    AdminStandardsIcons,
    AdminUsersIcons,
} from '@components/_atoms/icons';
import TitleWithHelpLink from '@components/_molecules/TitleWithHelpLink';
import ContentController from '@components/_organisms/Headers/ContentController';
import { InfoCardTemplate } from '@components/_templates/InfoCardTemplate';
import { NavigationPath } from '@utils/getMenuContent';
import s from './admin-dashboard-page.module.scss';

function AdminStart(): ReactNode {
    return (
        <LoadingBlur loading={false} style={{ width: '100%' }}>
            <InfoCardTemplate>
                <ContentController
                    title={
                        <TitleWithHelpLink
                            label="Admin"
                            link="https://wiki.siemens-energy.com/x/9Yf3FQ"
                        />
                    }
                />
                <div className="content-area p-content">
                    <nav aria-label="Admin menu">
                        <div className={s.grid}>
                            <div className={s.gridItem}>
                                <Link to={NavigationPath.AdminUsers}>
                                    <Card dropShadow>
                                        <AdminUsersIcons />
                                        <h2>Users</h2>
                                    </Card>
                                </Link>
                            </div>
                            <div className={s.gridItem}>
                                <Link to={NavigationPath.AdminStandards}>
                                    <Card dropShadow>
                                        <AdminStandardsIcons />
                                        <h2>Standards</h2>
                                    </Card>
                                </Link>
                            </div>
                            <div className={s.gridItem}>
                                <Link to={NavigationPath.AdminRequirements}>
                                    <Card dropShadow>
                                        <AdminRequirementsIcons />
                                        <h2>Requirements</h2>
                                    </Card>
                                </Link>
                            </div>
                            <div className={s.gridItem}>
                                <Link to={NavigationPath.AdminMappings}>
                                    <Card dropShadow>
                                        <AdminMappingsIcons />
                                        <h2>Mappings</h2>
                                    </Card>
                                </Link>
                            </div>
                            <div className={s.gridItem}>
                                <Link to={NavigationPath.AdminPss}>
                                    <Card dropShadow>
                                        <AdminPSSProjectClassificationTemplatesIcons />
                                        <h2>
                                            PSS project classification templates
                                        </h2>
                                    </Card>
                                </Link>
                            </div>
                            <div className={s.gridItem}>
                                <Link
                                    to={NavigationPath.AdminSupplierAssessments}
                                >
                                    <Card dropShadow>
                                        <AdminPSSProjectClassificationTemplatesIcons />
                                        <h2>3rd party Supplier Assessments</h2>
                                    </Card>
                                </Link>
                            </div>
                        </div>
                    </nav>
                </div>
            </InfoCardTemplate>
        </LoadingBlur>
    );
}

export default AdminStart;
